/* eslint-disable no-use-before-define */
import React from 'react'
import { publish, trackPage, isObject } from '../twd'
import { data } from './tools-and-resources-data'

export default () => {
    const { tools, resources } = data()
    trackPage('tools-and-resources')

    return <React.Fragment>

    { tools.length>0 && (
        <div className="container">
        <div className="row vertical-offset-lg">
        <div className="col-xs-12">
            <div className="vertical-offset-lg"/>
            <h2 className="h1 vertical-offset-sm text-center">Bond Tools</h2>
            <div className="card-group">
            {
                tools.map((a,i) => (<Card key={i} card={a} />))
            }
           </div>
        </div>
        </div>
        </div>
    )}


    { resources.length>0 && (
        <div style={{background:"#f6f6f6"}}>
        <div className="container">
        <div className="row vertical-offset-lg">
        <div className="col-xs-12">
            <div className="vertical-offset-lg"/>
            <h2 className="h1 vertical-offset-sm text-center">Bond Resources</h2>
            <div className="card-group">
            {
                resources.map((a,i) => (<Card key={i} card={a} />))
            }
           </div>
        </div>
        </div>
        </div>
        </div>
    )}

    </React.Fragment>

}

const Card = ({card}) => {
    let {title, description, tag, img, nav, navArg} = card

    let Tag = `${tag==='button' ? 'button' : 'a'}`

    return <div
            data-name="tools-and-resources-card"
            data-label={title}
            className="card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3"
            style={{cursor:'pointer'}}
            onClick={(e) => {
                if (!nav) return
                publish(nav, isObject(navArg) ? {source:e.target, ...navArg} : navArg)
            }}
        >
        {img && <img aria-hidden="true" src={img} alt={title} className="vertical-offset-sm" />}
        <div className="card-body">
            <h3 className="card-title">
                <Tag
                href="#"
                className="btn-link"
                data-name="tools-and-resources-card-link"
                data-label={title}
                aria-label={title}
            >{title}</Tag></h3>

            <div className="vertical-offset-base">
                {description}
            </div>
        </div>
    </div>
}